import {http} from "../config/Constantes";

export default class DelegacaoTarefaService {

    listarDelegacoes(usuarioResponsavel, usuarioDelegado){
        return http.get("/delegacaoTarefa/"+usuarioResponsavel+ "/"+usuarioDelegado);
    }

    listarDelegacoesUsuario(){
        return http.get("/delegacaoTarefa/usuario");
    }

    cadastrarDelegacoes(dadosParaCadastro){
        return http.post("/delegacaoTarefa", dadosParaCadastro);
    }

    deletarDelegacoes(id) {
        return http.delete("/delegacaoTarefa/" + id);
    }

    editarDelegacao(dadosDeEdicao){
        return http.put("/delegacaoTarefa", dadosDeEdicao);
    }
}